import { serializable, alias, object, list, primitive } from 'serializr';

export class ProductTransportation {
  @serializable
  id?: number;

  @serializable
  type?: string;

  @serializable(alias('product_raw_material_id', primitive()))
  productRawMaterialId?: number;

  @serializable(alias('supplier_id', primitive()))
  supplierId?: number;

  @serializable(alias('temperature_control', primitive()))
  temperatureControl?: string;

  @serializable(alias('transportation_air', primitive()))
  transportationAir?: boolean;

  @serializable
  origin?: string;
}
